import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/best-cats-for-attack";
const { Content } = Layout;
// const convertBasedOnLevel = require("../../table/calc-stats");

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Meatshields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title =
      "Best Cats for Meatshields | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "093-3",
        name: "Manic Eraser Cat",
        number: "093-3",
        form: "True",
        rarity: "Super Rare",
        level: 1,
        health: 3275,
        damage: 18,
        range: 110,
        kb: 1,
        speed: 20,
        dps: 8,
        target: "Area",
        tba: "2.23",
        anim: "0.27",
        spawn: "2.00",
        cost: 150,
        ability: " ",
        iscrazed: true,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "002-3",
        name: "Eraser Cat",
        number: "002-3",
        form: "True",
        rarity: "Basic",
        level: 1,
        health: 1500,
        damage: 10,
        range: 110,
        kb: 1,
        speed: 8,
        dps: 5,
        target: "Area",
        tba: "2.23",
        anim: "0.27",
        spawn: "2.00",
        cost: 150,
        ability: " ",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "149-3",
        name: "Ramen Cat",
        number: "149-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 2625,
        damage: 150,
        range: 120,
        kb: 1,
        speed: 8,
        dps: 450,
        target: "Single",
        tba: "0.33",
        anim: "0.17",
        spawn: "3.87",
        cost: 315,
        ability: "u1Against angelu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "201-2",
        name: "Metal Macho",
        number: "201-2",
        form: "Evolved",
        rarity: "Super Rare",
        level: 1,
        health: 2.5,
        damage: 20,
        range: 140,
        kb: 2,
        speed: 10,
        dps: 16,
        target: "Single",
        tba: "1.23",
        anim: "0.27",
        spawn: "17.87",
        cost: 600,
        ability:
          "u1General Abilitiesu2: b1Metalb2 (Only takes 1 damage from any attack, except critical hits)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "038-3",
        name: "Jiangshi Cat",
        number: "038-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 1000,
        damage: 262,
        range: 150,
        kb: 3,
        speed: 10,
        dps: 160,
        target: "Single",
        tba: "1.63",
        anim: "0.53",
        spawn: "2.00",
        cost: 240,
        ability:
          "u1General Abilitiesu2: b1Surviveb2 (100% chance to survive a lethal strike)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "211-3",
        name: "Li'l Eraser Cat",
        number: "211-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 1200,
        damage: 10,
        range: 100,
        kb: 1,
        speed: 6,
        dps: 5,
        target: "Area",
        tba: "2.23",
        anim: "0.27",
        spawn: "2.00",
        cost: 150,
        ability: "u1Not affected byu2: b1Freezeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "302-1",
        name: "Kyubey Cat",
        number: "302-1",
        form: "Normal",
        rarity: "Rare",
        level: 1,
        health: 250,
        damage: 20,
        range: 140,
        kb: 3,
        speed: 9,
        dps: 15,
        target: "Single",
        tba: "1.23",
        anim: "0.27",
        spawn: "2.00",
        cost: 90,
        ability:
          "u1General Abilitiesu2: b1Surviveb2 (40% chance to survive a lethal strike)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const bestCatsTwo = [
      {
        key: "637-2",
        name: "Brainwashed Wall Cat",
        number: "637-2",
        form: "Evolved",
        rarity: "Super Rare",
        level: 1,
        health: 1250,
        damage: 5,
        range: 110,
        kb: 1,
        speed: 14,
        dps: 2,
        target: "Area",
        tba: "2.23",
        anim: "0.27",
        spawn: "4.20",
        cost: 210,
        ability: "u1Against whiteu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "657-3",
        name: "Haniwa Cat",
        number: "657-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 800,
        damage: 8,
        range: 120,
        kb: 1,
        speed: 4,
        dps: 5,
        target: "Single",
        tba: "1.80",
        anim: "0.77",
        spawn: "2.00",
        cost: 135,
        ability:
          "u1Against whiteu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Behemoth Slayerb2 (inflicts 2.5x damage, takes only 0.6x damage, 5% chance to dodge for 1.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "653-2",
        name: "Chalkboard Punk Cat",
        number: "653-2",
        form: "Evolved",
        rarity: "Special",
        level: 1,
        health: 625,
        damage: 5,
        range: 110,
        kb: 1,
        speed: 7,
        dps: 2,
        target: "Area",
        tba: "2.23",
        anim: "0.27",
        spawn: "2.00",
        cost: 150,
        ability: "u1Against redu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "377-3",
        name: "Catellite",
        number: "377-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 2000,
        damage: 812,
        range: 120,
        kb: 1,
        speed: 12,
        dps: 268,
        target: "Single",
        tba: "3.03",
        anim: "0.67",
        spawn: "3.87",
        cost: 270,
        ability:
          "u1Against alienu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)\r\nu1Not affected byu2: b1Weakenb2, b1Slowb2, b1Warpb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "611-3",
        name: "King Nekokhamen",
        number: "611-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 750,
        damage: 5,
        range: 110,
        kb: 1,
        speed: 8,
        dps: 2,
        target: "Area",
        tba: "2.27",
        anim: "0.37",
        spawn: "2.00",
        cost: 150,
        ability:
          "u1Against floatingu2: b1Resistantb2 (only takes 0.25x damage)\nu1Not affected byu2: b1Toxicb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "524-3",
        name: "Shigong Cat",
        number: "524-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 2400,
        damage: 682,
        range: 120,
        kb: 1,
        speed: 9,
        dps: 380,
        target: "Single",
        tba: "1.80",
        anim: "1.17",
        spawn: "5.87",
        cost: 360,
        ability:
          "u1Against zombieu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving) b1Multi-hit attackb2 (Attacks thrice consecutively)\nu1Not affected byu2: b1Slowb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "149-3",
        name: "Ramen Cat",
        number: "149-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 2625,
        damage: 150,
        range: 120,
        kb: 1,
        speed: 8,
        dps: 450,
        target: "Single",
        tba: "0.33",
        anim: "0.17",
        spawn: "3.87",
        cost: 315,
        ability: "u1Against angelu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "670-3",
        name: "Cat Cactus",
        number: "670-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 2925,
        damage: 938,
        range: 140,
        kb: 1,
        speed: 8,
        dps: 292,
        target: "Single",
        tba: "3.20",
        anim: "0.57",
        spawn: "4.20",
        cost: 330,
        ability:
          "u1Against akuu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)\nu1Not affected byu2: b1Surgeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "453-3",
        name: "Future Cat",
        number: "453-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 1625,
        damage: 20,
        range: 140,
        kb: 1,
        speed: 10,
        dps: 18,
        target: "Single",
        tba: "1.20",
        anim: "0.37",
        spawn: "5.20",
        cost: 105,
        ability:
          "u1Against metal, relicu2: b1Insanely Toughb2 (only takes 0.17x damage)\nu1Not affected byu2: b1Curseb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "089-3",
        name: "Noodle Cats",
        number: "089-3",
        form: "True",
        rarity: "Rare",
        level: 1,
        health: 1000,
        damage: 188,
        range: 170,
        kb: 3,
        speed: 10,
        dps: 148,
        target: "Single",
        tba: "1.27",
        anim: "0.30",
        spawn: "2.00",
        cost: 360,
        ability:
          "u1Against metalu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Criticalb2 (3% chance of a critical hit)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "631-2",
        name: "Tea Master Cat",
        number: "631-2",
        form: "Evolved",
        rarity: "Rare",
        level: 1,
        health: 950,
        damage: 562,
        range: 330,
        kb: 1,
        speed: 10,
        dps: 259,
        target: "Single",
        tba: "2.17",
        anim: "0.60",
        spawn: "8.53",
        cost: 510,
        ability:
          "u1Against relicu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)\nu1Not affected byu2: b1Curseb2, b1Waveb2, b1Surgeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "671-3",
        name: "Armored Firefly Cat",
        number: "671-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 1875,
        damage: 165,
        range: 210,
        kb: 1,
        speed: 10,
        dps: 82,
        target: "Area",
        tba: "2.00",
        anim: "0.83",
        spawn: "4.87",
        cost: 450,
        ability:
          "u1Against red, alienu2: b1Weakenb2 (50% chance to weaken by 50% for 3.0s) \nu1General Abilitiesu2: b1Behemoth Slayerb2 (inflicts 2.5x damage, takes only 0.6x damage, 5% chance to dodge for 1.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Best Cats
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_LEADERBOARD} />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Best Cats for Meatshields
                </h2>
                <p></p>
                <div>
                  Ever wondered if you’re really using the best meatshield for
                  your stage? Which meatshields have the best defense, and is
                  one much better than another? What about meatshields that are
                  best for certain enemy types?
                </div>
                <p></p>
                <div>
                  Comparing the stats for the best meatshields gives us the list
                  below.
                </div>
                <p></p>
                <i>Last updated: 5 February 2023</i>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Meatshields"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Meatshields"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A ruthless Cat wearing a cute animal
                  costume. Evolved for improved stylishness and adorability.
                  Might Survive a lethal attack.
                  <p></p>
                  <b>Other forms: </b>Tank Kyubey Cat
                  <p></p>
                  <b>Pros: </b>It’s unfortunate that he doesn’t have a true
                  form, as he’s superior to non-true forms of{" "}
                  <Link to={"/catinfo/038/Jiangshi%20Cat"}>Jiangshi Cat</Link>.
                  With a lower cost and knockbacks, and nearly the same chance
                  to Survive, he is a better frontline defender. Can also act as
                  a very cheap{" "}
                  <Link to={"/catinfo/038/Jiangshi%20Cat"}>Jiangshi Cat</Link>{" "}
                  in normal form.
                  <p></p>
                  <b>Cons: </b>With{" "}
                  <Link to={"/catinfo/038/Jiangshi%20Cat"}>Jiangshi Cat's</Link>{" "}
                  true form granting him both a lower cost and a 100% chance for
                  him to Survive, he outshines Kyubey on most stages.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Kyubey Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}

            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A tiny guy with dreams of becoming that
                  Cat famous for Really Good™ Defense. Same attack power as
                  always. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Li'l Tank Cat, Li'l Wall Cat
                  <p></p>
                  <b>Pros: </b>Imagine an{" "}
                  <Link to={"/catinfo/002/Eraser%20Cat"}>Eraser Cat</Link>, but
                  smaller and cuter! This means that he has slightly lower
                  health, but is your only option on stages where you can only
                  use Special cats, such as{" "}
                  <Link to={"/stageinfo/300636/Aguham"}>Aguham</Link> in Cats of
                  the Cosmos.
                  <p></p>
                  <b>Cons: </b>Not useful in most stages, as you’d usually
                  choose Eraser Cat over him.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Li'l Eraser Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Horror movie maniac, or real g-g-ghost? Mystic seal is just
                  this month's gas bill… Cheap to produce, 100% survives once!
                  <p></p>
                  <b>Other forms: </b>Pogo Cat, Masai Cat
                  <p></p>
                  <b>Pros: </b>Effectively acts as 2 meatshields thanks to
                  having 100% chance to Survive in his True form. His decent
                  attack ability also allows him to clear up some of the peons.
                  <p></p>
                  <b>Cons: </b>It’s better to use him as a cat that absorbs
                  blows in lieu of another, as his multiple knockbacks make it
                  difficult for him to hold up the frontline. He shines in
                  stages with extremely strong enemies, such as the{" "}
                  <Link to={"/enemyinfo/070/Black%20Cyclone"}>
                    Black Cyclone
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Jiangshi Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Metal skin reduces all damage taken to a minimum. Proud of his
                  beautiful skin, leaves his arms uncovered. Can't upgrade to
                  (+) levels. (Metal)
                  <p></p>
                  <b>Other forms: </b>Metal Cat
                  <p></p>
                  <b>Pros: </b>Exceptional against strong enemies as he’ll
                  survive 17 hits at level 30 (as long as they’re not critical
                  hits). This makes him perfect for stages where there are few
                  enemy peons and strong bosses, such as{" "}
                  <Link to={"/enemyinfo/039/THE%20SLOTH"}>THE SLOTH</Link>.
                  <p></p>
                  <b>Cons: </b>His slow movement speed and higher cost means
                  you’ll need to wait a while for your money to accumulate at
                  the start before sending him out for him to reach the
                  frontline in time. His higher respawn time also makes it risky
                  to rely only on him for meatshielding. Don’t be cheated by his
                  new appearance, there’s absolutely no difference in his stats
                  between his normal and evolved forms.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Metal Macho"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A Noodles might seem like a simple dish,
                  but they need an artist's touch to master. Flashy prep style
                  also boosts defense vs Angels.
                  <p></p>
                  <b>Other forms: </b>Rocker Cat, Artist Cat
                  <p></p>
                  <b>Pros: </b>This versatile meatshield doubles as a powerhouse
                  that can easily clear enemy peons and help your frontline inch
                  forward. It has nearly the same health as{" "}
                  <Link to={"catinfo/093/Manic%20Eraser%20Cat"}>
                    Manic Eraser Cat
                  </Link>{" "}
                  but a DPS that ranks amongst the top 10 amongst Rare cats
                  thanks to his fast attack rate. While he doesn’t perform as
                  well in Black enemy stages, using him against Angel enemies is
                  a no-brainer and all other enemy types are fair game. Overall,
                  he is a well-balanced cat that plays a complementary role to
                  the typical meatshields in this list and can often be found in
                  the same lineups.
                  <p></p>
                  <b>Cons: </b>His higher cost and respawn time are tradeoffs to
                  his functionality as a meatshield. His single target attack
                  also limits his ability to push forward at times.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ramen Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Can take a beating thanks to elasticity. Really Good ™
                  Defense. (Area Attack) Strong enough to move two small rocks.
                  <p></p>
                  <b>Other forms: </b>Tank Cat, Wall Cat
                  <p></p>
                  <b>Pros: </b>A stalwart defender which is with you from the
                  start. The fact that he is much more easily obtainable than{" "}
                  <Link to={"catinfo/093/Manic%20Eraser%20Cat"}>
                    Manic Eraser Cat
                  </Link>{" "}
                  gives him a boost in this ranking. He is also far slower,
                  creating a more solid defense line.
                  <p></p>
                  <b>Cons: </b>His health is only around half of{" "}
                  <Link to={"catinfo/093/Manic%20Eraser%20Cat"}>
                    Manic Eraser Cat's
                  </Link>
                  , although this may not matter as much in endgame stages where
                  the enemies can one hit KO them anyway.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Eraser Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Can take a beating thanks to elasticity. Manic version grants
                  even more Really Good ™ Defense. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Crazed Tank Cat, Crazed Wall Cat
                  <p></p>
                  <b>Pros: </b>By far the most resilient general-use meatshield
                  in the game, creating a solid frontline impenetrable to
                  enemies. With its speed, it quickly repositions itself at the
                  front to take the hit for its cat allies. His health gets a
                  good best in true form, but even in evolved form it’s still
                  superior to{" "}
                  <Link to={"catinfo/002/Eraser%20Cat"}>Eraser Cat</Link>.
                  <p></p>
                  <b>Cons: </b>Beware of it charging ahead at the start, which
                  may trigger the enemy boss when you’re not yet ready. As is
                  the case for most of these meatshields, it suffers from having
                  a low DPS and is strictly used only for meatshielding
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Manic Eraser Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  Bonus: Best Meatshields for each enemy type
                </Divider>
                <p></p>
                <div>
                  <b>White: </b>{" "}
                  <Link to={"catinfo/637/Brainwashed%20Wall%20Cat"}>
                    Brainwashed Wall Cat
                  </Link>{" "}
                  (Other forms: Brainwashed Tank Cat),{" "}
                  <Link to={"catinfo/657/Haniwa%20Cat"}>Haniwa Cat</Link> (Other
                  forms: Ancient Egg N001. Mystic Egg N001)
                  <p></p>
                  <b>Red: </b>
                  <Link to={"catinfo/653/Chalkboard%20Punk%20Cat"}>
                    Chalkboard Punk Cat
                  </Link>{" "}
                  (Other forms: Chalkboard Eraser Cat)
                  <p></p>
                  <b>Alien: </b>
                  <Link to={"catinfo/377/Catellite"}>Catellite</Link> (Other
                  forms: Rover Cat, Rover Cat Mk II)
                  <p></p>
                  <b>Floating: </b>
                  <Link to={"catinfo/611/King%20Nekokhamen"}>
                    King Nekokhamen
                  </Link>{" "}
                  (Other forms: Gold Brick Cat, King Ingot Cat)
                  <p></p>
                  <b>Zombie: </b>
                  <Link to={"catinfo/524/Shigong%20Cat"}>Shigong Cat</Link>{" "}
                  (Other forms: Wushu Cat, Sifu Cat)
                  <p></p>
                  <b>Black: </b>None (default to the general-use meatshields)
                  <p></p>
                  <b>Angel: </b>
                  <Link to={"catinfo/149/Ramen%20Cat"}>Ramen Cat</Link> (Other
                  forms: Rocker Cat, Artist Cat)
                  <p></p>
                  <b>Aku: </b>
                  <Link to={"catinfo/670/Cat%20Cactus"}>Cat Cactus</Link> (Other
                  forms: Ancient Egg: N003, Evil Egg: N003)
                  <p></p>
                  <b>Metal: </b>
                  <Link to={"catinfo/453/Future%20Cat"}>Future Cat</Link> (Other
                  forms: Primordial Cat, Modern Cat),{" "}
                  <Link to={"catinfo/089/Noodle%20Cats"}>Noodle Cats</Link>{" "}
                  (Other forms: Rope Jump Cat, Pair Rope Jump Cat)
                  <p></p>
                  <b>Relic: </b>
                  <Link to={"catinfo/453/Future%20Cat"}>Future Cat</Link> (Other
                  forms: Primordial Cat, Modern Cat),{" "}
                  <Link to={"catinfo/631/Tea%20Master%20Cat"}>
                    Tea Master Cat
                  </Link>{" "}
                  (Other forms: WCalligraphy Cat)
                  <p></p>
                  <b>Behemoth: </b>
                  <Link to={"catinfo/671/Armored%20Firefly%20Cat"}>
                    Armored Firefly Cat
                  </Link>{" "}
                  (Other forms: Ancient Egg: N202, Cinnabar Egg: N202),{" "}
                  <Link to={"catinfo/657/Haniwa%20Cat"}>Haniwa Cat</Link> (Other
                  forms: Ancient Egg N001. Mystic Egg N001)
                  <p></p>
                </div>
              </Row>
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare the 7 general-use meatshields below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare the 12 specific-use meatshields below</h3>
              <BestCatsTable
                selectedCats={bestCatsTwo}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="6015153906"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Meatshields;

Meatshields.propTypes = {
  applyViewportChange: PropTypes.number,
};

Meatshields.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/bestcats/Meatshields.js